import styled from "styled-components";

export const RadioContainer = styled.div`
  display: flex;
  align-items: center;

  & > div {
    margin-right: 46px;
  }
`;
